import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=73c8b14b&scoped=true&"
var script = {}
import style0 from "./Main.vue?vue&type=style&index=0&id=73c8b14b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c8b14b",
  null
  
)

export default component.exports